/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BuildingItemDto } from './buildingItemDto';


export interface ProfiNeoSyncStateItemDto { 
    id: string;
    building?: BuildingItemDto;
    syncStatus: ProfiNeoSyncStateItemDto.SyncStatusEnum;
    syncType: ProfiNeoSyncStateItemDto.SyncTypeEnum;
    lastSyncDate?: string;
    profiNeoLocationAddressId?: string;
    profiNeoProjectId?: string;
    profiNeoManualProjectId?: string;
    profiNeoSectionAddressIds?: string;
}
export namespace ProfiNeoSyncStateItemDto {
    export type SyncStatusEnum = 'PENDING' | 'QUEUED' | 'COMPLETED' | 'FAILED';
    export const SyncStatusEnum = {
        Pending: 'PENDING' as SyncStatusEnum,
        Queued: 'QUEUED' as SyncStatusEnum,
        Completed: 'COMPLETED' as SyncStatusEnum,
        Failed: 'FAILED' as SyncStatusEnum
    };
    export type SyncTypeEnum = 'LEGACY' | 'SANIERUNG';
    export const SyncTypeEnum = {
        Legacy: 'LEGACY' as SyncTypeEnum,
        Sanierung: 'SANIERUNG' as SyncTypeEnum
    };
}


